import {
  IAssistantAllowedRecipient,
  IAssistantThread,
  IAssistantThreadRun,
  ICreateAllowedRecipient,
  IDetailedThread,
  ITemplateAttachedField,
} from "types/assistant.service";
import { apiClient } from "./clients";

class DealAssistantService {
  private readonly basePath = (dealId: string) => `fund/${dealId}/assistant`;

  async getFields(dealId: string): Promise<ITemplateAttachedField[]> {
    const { data } = await apiClient.get(`${this.basePath(dealId)}/fields`);

    return data;
  }

  async getThreads(dealId: string): Promise<IAssistantThread[]> {
    const { data } = await apiClient.get(`${this.basePath(dealId)}/threads`);

    return data;
  }

  async getThreadById(
    dealId: string,
    threadId: string
  ): Promise<IDetailedThread> {
    const { data } = await apiClient.get(
      `${this.basePath(dealId)}/threads/${threadId}`
    );

    return data;
  }

  async createFieldThread(
    dealId: string,
    fieldId: string
  ): Promise<IAssistantThread> {
    const { data } = await apiClient.post(
      `${this.basePath(dealId)}/fields/${fieldId}/threads`
    );

    return data;
  }

  async createThread(dealId: string, name: string | null) {
    const { data } = await apiClient.post(`${this.basePath(dealId)}/threads`, {
      name,
    });

    return data;
  }

  async updateThread(dealId: string, threadId: string, name: string) {
    const { data } = await apiClient.put(
      `${this.basePath(dealId)}/threads/${threadId}`,
      {
        name,
      }
    );

    return data;
  }

  async deleteThread(dealId: string, threadId: string): Promise<void> {
    await apiClient.delete(`${this.basePath(dealId)}/threads/${threadId}`);
  }

  async addThreadMessage(
    dealId: string,
    threadId: string,
    content: string
  ): Promise<IAssistantThreadRun> {
    const { data } = await apiClient.post(
      `${this.basePath(dealId)}/threads/${threadId}/messages`,
      {
        Role: "user",
        content,
      }
    );

    return data;
  }

  async toggleDealAssistant(dealId: string, isEnabled: boolean): Promise<void> {
    await apiClient.put(`${this.basePath(dealId)}/enable`, {
      isEnabled,
    });
  }

  async getAllowedRecipients(
    dealId: string
  ): Promise<PaginatedTokenResponse<IAssistantAllowedRecipient>> {
    const { data } = await apiClient.get(
      `${this.basePath(dealId)}/allowed-recipients`
    );

    return data;
  }

  async deleteAllowedRecipient(
    dealId: string,
    email: string
  ): Promise<IAssistantAllowedRecipient[]> {
    const { data } = await apiClient.delete(
      `${this.basePath(dealId)}/allowed-recipients`,
      { params: { email } }
    );

    return data;
  }

  async addAllowedRecipients(
    dealId: string,
    payload: ICreateAllowedRecipient[]
  ): Promise<IAssistantAllowedRecipient[]> {
    const { data } = await apiClient.post(
      `${this.basePath(dealId)}/allowed-recipients`,
      payload
    );

    return data;
  }
}

export default new DealAssistantService();
